/* Íconos de relleno sólido (estrella, comillas): el sprite los declara con fill="currentColor". */
svg.filled {
  fill: currentColor;
  stroke: none;
}
